import { combineReducers } from 'redux'

import airDna from './airDna'
import affordability from './affordability'
import bombBomb from './bombBomb'
import buyerInfo from './buyerInfo'
import buyerUnsubscribe from './buyer/unsubscribe'
import client from './client'
import homeInsurance from './homeInsurance'
import customerProfile from './customerProfile'
import home from './home'
import homeCreate from './homeCreate'
import homeowner from './homeowner'
import homePreview from './homePreview'
import homeUnsubscribe from './home/unsubscribe'
import invite from './invite'
import latestMortgageRates from './latestMortgageRates'
import layout from './layout'
import loan from './loan'
import locale from './locale'
import mortgageRates from './mortgageRates'
import mapbox from './mapbox'
import marketRecords from './marketRecords'
import navigation from './navigation'
import notification from './notification'
import powerUps from './powerUps'
import refinance from './refinance'
import sponsor from './sponsor'
import streamNotifications from './streamNotifications'
import tca from './tca'
import trackingSource from './trackingSource'
import transitions from './transitions'
import valuation from './valuation'
import valuationHistory from './valuationHistory'
import ylopo from './ylopo'
import zipModal from './zipModal'

export default combineReducers({
  airDna,
  affordability,
  bombBomb,
  buyerInfo,
  buyerUnsubscribe,
  client,
  homeInsurance,
  customerProfile,
  home,
  homeCreate,
  homeowner,
  homePreview,
  homeUnsubscribe,
  invite,
  latestMortgageRates,
  layout,
  loan,
  locale,
  mortgageRates,
  mapbox,
  marketRecords,
  navigation,
  notification,
  powerUps,
  refinance,
  sponsor,
  streamNotifications,
  tca,
  trackingSource,
  transitions,
  valuation,
  valuationHistory,
  ylopo,
  zipModal
})
